import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "AddCustomProductModal"
}
const _hoisted_2 = { class: "AddCustomProductModalHeaderBlock" }
const _hoisted_3 = {
  key: 0,
  class: "CampaignEditorRow"
}
const _hoisted_4 = { class: "CampaignEditorRightColumn" }
const _hoisted_5 = { class: "CampaignEditorRow" }
const _hoisted_6 = { class: "CampaignEditorRightColumn" }
const _hoisted_7 = { class: "CampaignEditorRow" }
const _hoisted_8 = { class: "CampaignEditorRightColumn" }
const _hoisted_9 = { class: "CampaignEditorRow RowWithDateElement" }
const _hoisted_10 = { class: "CampaignEditorLeftColumn" }
const _hoisted_11 = { class: "CampaignEditorRightColumn DateWrapper" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "CampaignEditorRow" }
const _hoisted_14 = { class: "CampaignEditorRightColumn" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "NavigatorButton CustomProductModalButton",
  type: "submit",
  value: "Add updates"
}
const _hoisted_18 = {
  key: 3,
  class: "DeleteButtonsWrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.modalTitle), 1 /* TEXT */)
    ]),
    _createElementVNode("form", {
      class: "CustomProductModalContentBlock",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      (!_ctx.modalStateIsDeleteProduct)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.modalStateIsEditProduct)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
                    _createElementVNode("label", { class: "CampaignEditorInputLabel CampaignSettingsInputRequired" }, " Custom product type ")
                  ], -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_MultiSelect, {
                      ref: "typeDropdown",
                      class: "CampaignEditorDropdown",
                      options: _ctx.customProductOptions,
                      onUpdated: _ctx.updateProductType
                    }, null, 8 /* PROPS */, ["options", "onUpdated"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
                _createElementVNode("label", { class: "CampaignEditorInputLabel" }, " Title ")
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Custom product name",
                  class: "CampaignEditorInputField",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productName) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.productName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
                _createElementVNode("label", { class: "CampaignEditorInputLabel CampaignSettingsInputRequired" }, " Price ")
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  placeholder: "Custom price",
                  class: "CampaignEditorInputField",
                  required: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productPrice) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.productPrice]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", {
                  class: _normalizeClass([
							'CampaignEditorInputLabel',
							'CampaignSettingsInputRequired',
							{ 'ContentInvalid': _ctx.isDeliveryDateFieldValidatedAndInvalid }
						])
                }, " Delivery date ", 2 /* CLASS */)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass([
							'DateWrapper',
							{ 'ContentInvalid': _ctx.isDeliveryDateFieldValidatedAndInvalid }
						])
                }, [
                  _createElementVNode("input", {
                    type: "date",
                    class: "CampaignEditorDatePicker",
                    value: _ctx.productDateAsDateString,
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setDate && _ctx.setDate(...args))),
                    required: ""
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_12)
                ], 2 /* CLASS */),
                _createElementVNode("div", {
                  class: _normalizeClass([
							'ValidationMessage',
							{ 'ContentInvalid': _ctx.isDeliveryDateFieldValidatedAndInvalid }
						])
                }, " Delivery Date must be within the campaign start and end date ", 2 /* CLASS */)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
                _createElementVNode("label", { class: "CampaignEditorInputLabel" }, " Internal description ")
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("textarea", {
                  placeholder: "Type your notes here",
                  class: "CampaignEditorTextarea",
                  rows: 4,
                  value: _ctx.productDescription,
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setDescription && _ctx.setDescription(...args)))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_15)
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock("p", _hoisted_16, [
            _cache[11] || (_cache[11] = _createTextVNode(" Are you sure you want to delete custom product", -1 /* CACHED */)),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("em", null, _toDisplayString(_ctx.productName), 1 /* TEXT */),
            _cache[13] || (_cache[13] = _createTextVNode(" ? ", -1 /* CACHED */))
          ])),
      (_ctx.modalStateIsEditProduct)
        ? (_openBlock(), _createElementBlock("input", _hoisted_17))
        : (_ctx.modalStateIsDeleteProduct)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _cache[14] || (_cache[14] = _createElementVNode("input", {
                class: "DriverButton CustomProductModalButton",
                type: "submit",
                value: "Delete product"
              }, null, -1 /* CACHED */)),
              _createElementVNode("button", {
                type: "button",
                class: "HelperButton CampaignEditorHelperButton CustomProductModalButton",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, " Cancel ")
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _cache[15] || (_cache[15] = _createElementVNode("input", {
                class: "ChampionButton CustomProductModalButton",
                type: "submit",
                value: "Add product"
              }, null, -1 /* CACHED */)),
              _createElementVNode("button", {
                class: "NavigatorButton CustomProductModalButton",
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addCustomProduct(true)))
              }, " Add & duplicate ")
            ], 64 /* STABLE_FRAGMENT */))
    ], 32 /* NEED_HYDRATION */)
  ], 512 /* NEED_PATCH */))
}